import ContentContainer from '../../../templates/Content/ContentContainer';

const PermissionGroups = () => (
  <ContentContainer title="x">
    <h1>Impostos</h1>
  </ContentContainer>
);

export default PermissionGroups;
